module.exports = __webpack_public_path__ + "img/44.cleaner.abde743e.svg";